
import {useState} from 'react';
import {Routes} from 'constants/index';
import {hasWindow} from 'utils/functions';

const showCopiedMs = 1000;
const startText = 'Copy';
const copiedText = 'Copied!';

export const useCopy = (cache: string) => {
	const [text, setText] = useState<string>(startText);
	return {
		copied: text,
		onCopy: async () => {
			setText(copiedText);

			const link = makeLink(cache);
			if (link) {
				await navigator.clipboard.writeText(link);
			}

			setTimeout(() => {
				setText(startText);
			}, showCopiedMs);
		},
	};
};

export const makeLink = (cache: string): string => {
	if (!hasWindow()) {
		return '';
	}

	const {location: loc} = window;

	// Handle funky cases like the dashboard
	let pathname = loc.pathname;
	if (!pathname.includes(cache)) {
		pathname = `${Routes.sharedDexa}${cache}`;
	}

	// Construct full share path
	return [
		// https://www.bodyspec.com
		loc.protocol + '//' + loc.hostname,

		// <empty>
		(loc.port ? ':' + loc.port : ''),

		// /shared-dexa/<cache-id>
		pathname.replace(Routes.reportDexa, Routes.sharedDexa),
	].join('');
};
